import { call, put } from 'redux-saga/effects';
import {
  fetchTransactionAttachmentFailure,
  fetchTransactionAttachmentSuccess,
  manualJournalPostSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { FetchTransactionAttachmentRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import {
  getTransactionAttachment,
  TransactionAttachmentsResponse,
} from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { TransactionAttachment } from '../models/transactionAttachments';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchTransactionAttachment(
  action: FetchTransactionAttachmentRequestAction
) {
  try {
    let err: ApiError | null;
    const { tokenId, transactionId, transactionUuid, sourceType, receipts } =
      action.payload;

    const response: TransactionAttachmentsResponse = yield call(
      getTransactionAttachment,
      tokenId,
      transactionId,
      transactionUuid,
      sourceType,
      receipts
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    if (response.data?.files) {
      const transactionAttachments: TransactionAttachment[] =
        response.data.files;

      yield put(
        fetchTransactionAttachmentSuccess(
          transactionAttachments,
          transactionId,
          'fetch'
        )
      );
    } else {
      yield put(fetchTransactionAttachmentSuccess([], transactionId, 'fetch'));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchTransactionAttachmentFailure());
  }
}
